import React from "react";
import {
    SxProps,
    Theme,
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    TextField,
} from "@mui/material";
import { CommonStyles } from "../styles/CommonStyles";
import ReinovaButton from "./ReinovaButton";
import { useIsMobile } from "../hooks";
import { useTranslation } from "react-i18next";

interface Props {
    open: boolean;
    onSubmit: (text: string) => void;
    handleClose: () => void;
}

const SearchStandardDialogStyle: Record<string, SxProps<Theme>> = {
    dialogContainer: (theme: Theme) => ({
        background: "#282334",
        border: "2px solid",
        borderColor: theme.palette.secondary.main,
        borderRadius: "10px",
    }),
    dialogContainerMobile: (theme: Theme) => ({
        background: "#282334",
        border: "2px solid",
        borderColor: theme.palette.secondary.main,
        borderRadius: "10px",
    }),
    dialogTitle: {
        fontSize: "1.5rem",
    },
    dialogDate: {
        color: "#BABABA",
    },
    dialogContent: {
        marginTop: "20px",
    },
    dialogContentText: {
        fontSize: "1.2rem",
        color: "white",
    },
    dialogButton: {
        fontSize: "1rem",
        color: "white",
    },
};

const SearchStandardDialog: React.FC<Props> = ({
    open,
    onSubmit,
    handleClose,
}) => {
    const { isMobile, windowWidth } = useIsMobile();
    const { t } = useTranslation();
    const [standardQuery, setStandardQuery] = React.useState("");
    return (
        <Dialog
            PaperProps={{
                sx: isMobile
                    ? SearchStandardDialogStyle.dialogContainerMobile
                    : SearchStandardDialogStyle.dialogContainer,
            }}
            fullWidth
            maxWidth={"sm"}
            open={open}
            onClose={handleClose}
        >
            <form onSubmit={(e) => {
                e.preventDefault(); 
                onSubmit(standardQuery);
            }}>
                <DialogTitle sx={{ fontSize: isMobile ? "18px" : "22px" }}>
                    {t("testing.searchmodal.title")}
                </DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        inputProps={{
                            style: {
                                color: "white",
                            },
                        }}
                        value={standardQuery}
                        sx={[CommonStyles.formInput, { width: "100%" }].flat(2)}
                        size="small"
                        required
                        color="secondary"
                        placeholder="i. e. ISO, EN 60068, UN ECE R100"
                        onChange={(e) => setStandardQuery(e.target.value)}
                    />
                </DialogContent>
                <DialogActions sx={{ paddingRight: "25px" }}>
                    <ReinovaButton onClick={() => onSubmit(standardQuery)}>
                        {t("testing.searchmodal.button")}
                    </ReinovaButton>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default SearchStandardDialog;
